import React from "react";

const Card = ({
    toolbar,
    children,
    header = '',
    className = '',
    padding = false,
}) => {
    return (
        <div className={"card-bs " + className}>
            <div className="card-bs-header">
                <span>{header}</span>
            </div>
            <div className="card-toolbar">
                {toolbar != null &&
                    toolbar
                }
            </div>
            <div
                className="card-bs-body"
                data-padding={padding}
            >
                {children != null &&
                    children
                }
            </div>
        </div>
    );
}

export default Card;